<template>
  <div class="internet_join_info">
    <div class="i_e_title">가입(약속) 내역</div>
    <div class="i_e_con">
      <div class="con_txt btmb">
        <dl class="mb04">
          <dt class="txt_1">매장명</dt>
          <dd class="txt_2">
            {{ shop.name }}
          </dd>
        </dl>
        <dl class="mb04">
          <dt class="txt_1">전화 번호</dt>
          <dd class="txt_2">{{ shop.telNumber }}</dd>
        </dl>
        <dl>
          <dt class="txt_1">주소</dt>
          <dd class="txt_2">{{ shop.address }}</dd>
        </dl>
      </div>
      <div class="con_txt btmb">
        <dl class="mb04" v-if="applyCreated">
          <dt class="txt_1">신청일</dt>
          <dd class="txt_2">
            {{ applyCreated }}
          </dd>
        </dl>
        <dl class="mb04" v-if="item.joinType">
          <dt class="txt_1">개통구분</dt>
          <dd class="txt_2">
            {{ item.joinType }}
          </dd>
        </dl>
        <dl class="mb04" v-if="item.areaFullName">
          <dt class="txt_1">설치지역</dt>
          <dd class="txt_2">
            {{ item.areaFullName }}
          </dd>
        </dl>
        <dl class="mb04">
          <dt class="txt_1">통신사</dt>
          <dd class="txt_2">
            {{ item.telecom }}
          </dd>
        </dl>
        <dl>
          <dt class="txt_1">상품구성</dt>
          <dd class="txt_2">
            {{ item.item
            }}<span v-if="item.phoneTogether == 'PHONE'">+휴대폰</span
            ><span v-else-if="item.phoneTogether == 'USIM'">+USIM</span>
          </dd>
        </dl>
      </div>
      <div class="con_txt">
        <dl class="mb04 sb" v-if="!isPromotionView">
          <dt class="txt_1">요금제</dt>
          <dd class="txt_2 wcal">
            <div>[인터넷] {{ item.itemInternet }}</div>
            <div v-if="item.itemTv">[TV] {{ item.itemTv }}</div>
          </dd>
        </dl>
        <dl class="mb04 sb">
          <dt class="txt_1">월 요금</dt>
          <dd class="txt_2 brd">
            <div>{{ toCurrency(item.monthPrice) }}원</div>
            <div class="sub_txt">(부가세 포함)</div>
          </dd>
        </dl>
        <dl class="sb">
          <dt class="txt_1">약속지원금</dt>
          <dd class="txt_2 brd" v-if="item.promotionId > 0">
            {{
              toCurrency(
                item.cashSupport +
                  item.giftCardSupport +
                  item.giftItemSupport +
                  item.perceSupport,
              )
            }}원
          </dd>
          <dd class="txt_2 brd" v-else-if="isPromotionView">
            {{ getTotalPrice(item) | comma }}원
          </dd>
          <dd class="txt_2 brd" v-else>
            {{
              (item.cashSupport + item.giftCardSupport + item.giftItemSupport)
                | comma
            }}원
          </dd>
        </dl>
      </div>
      <div id="more_info" class="more_info">
        <div class="con_txt">
          <div class="con_txt_box">
            <div class="box_txt_2">
              <div v-if="item.promotionId > 0" class="txt_1 pbb tc">
                매장지원 {{ getNumberToKorean(item.cashSupport) }}원

                <span class="bk" v-if="item.giftCardSupport > 0">
                  (상품권{{ getNumberToKorean(item.giftCardSupport) }}원 포함)
                </span>
                + 퍼스지원
                {{ getNumberToKorean(item.perceSupport) }}원
              </div>
              <div v-else-if="isPromotionView" class="txt_1 pbb tc">
                요금할인(퍼스특별)
                {{ getPromotionSupportPrice(item) | comma }}원 + 상품권
                {{ getPromotionGiftPrice(item) | comma }}원
              </div>
              <div v-else class="txt_1 pbb tc">
                <div
                  v-if="
                    item.cashSupport > 0 ||
                      item.giftCardSupport > 0 ||
                      item.giftItemSupport > 0
                  "
                >
                  (
                  <span v-if="item.cashSupport > 0"
                    >{{ item.cashSupport | comma }}원 현금
                    <span
                      v-if="
                        item.giftCardSupport == 0 && item.giftItemSupport == 0
                      "
                      >지원</span
                    >
                  </span>
                  <span v-if="item.giftCardSupport > 0">
                    <span v-if="item.cashSupport > 0"> + </span>
                    {{ item.giftCardSupport | comma }}원 상품권
                    <span v-if="item.giftItemSupport == 0">지원</span>
                  </span>
                  <span v-if="item.giftItemSupport > 0">
                    <span
                      v-if="item.cashSupport > 0 || item.giftCardSupport > 0"
                    >
                      +
                    </span>
                    {{ item.giftItemSupport | comma }}원 사은품
                    <span>지원</span> </span
                  >)
                </div>
              </div>
              <div
                class="txt_2 pt"
                :class="{ pbb: item.memoSupport }"
                v-if="
                  item.cashRewardDate ||
                    item.contractMonth ||
                    item.usageMonth ||
                    item.installCost
                "
              >
                <div v-if="item.cashRewardDate">
                  * 지원금 {{ item.cashRewardDate }}지급<span
                    v-if="item.giftcardSendDate != '해당없음'"
                    >(상품권 {{ item.giftcardSendDate }} 지급)</span
                  >
                </div>
                <div v-if="item.contractMonth">
                  * 가입요금제 최소 {{ item.contractMonth }}개월
                  유지조건(3년약정)
                </div>
                <div v-if="item.usageMonth">
                  * {{ item.usageMonth }}개월 이내 해지 시 지원금 전액 환수 및
                  위약금 발생
                </div>
                <div v-if="item.installCost">
                  * 설치비 별도: 주중
                  {{ item.installCost | comma }}원
                  <span v-if="item.installCostWeekend"
                    >주말·야간 {{ item.installCostWeekend | comma }}원</span
                  >
                </div>
              </div>
              <div
                class="txt_2 pt"
                v-if="item.memoSupport"
                v-html="$options.filters.nl2br(item.memoSupport)"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="more_btm" @click="showDetailView()">
        <button class="btn_detail" id="btn_detail">
          <span></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as util from '@common/lib/common/utils.js';
import promotionCfg from '@common/lib/common/promotionCfg';

export default {
  name: 'component-internet-join-info',
  description: '인터넷 가입(약속)내역 컴포넌트',
  props: {
    item: Object,
    isPromotionView: {
      type: Boolean,
      default: false,
    },
    shop: Object,
    applyCreated: {
      type: String,
      default: '',
    },
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  methods: {
    _toBR(str) {
      console.log('itemitemitemitem');
      console.log(this.item);
      var st = `<p class="ct">${str}</p>`;
      return util.toBR(st);
    },
    toCurrency(val) {
      return util.toCurrency(val);
    },
    // itemList(item) {
    //   console.log('itemitemitemitem2222');
    //   console.log(item);

    //   let data = '';

    //   if (item.itemInternet != '' && item.itemInternet != undefined) {
    //     if (item.itemSpeed) {
    //       data = `[${item.itemSpeed} 인터넷] ${item.itemInternet}`;
    //     } else {
    //       let itemSpeed = item.item.split(' ');
    //       itemSpeed = itemSpeed[0];

    //       data = `[${itemSpeed} 인터넷] ${item.itemInternet}`;
    //     }
    //     if (item.itemTv != '' && item.itemTv != undefined) {
    //       data += `<br />`;
    //       data += `[TV] ${item.itemTv}`;
    //     }
    //   } else {
    //     const itemArr = item.item.split('+');

    //     if (item.phoneTogether == 'Y') {
    //       var ph = item.phoneTogether == 'Y' ? ' 휴대폰 동시구매' : '';
    //       itemArr.push(ph);
    //     }

    //     itemArr.forEach((it, index) => {
    //       if (it === '') return;
    //       if (itemArr.length === 1 || itemArr.length === index + 1) {
    //         data += `<p>${it}</p>`;
    //       } else {
    //         data += `<p>${it}&nbsp;|</p>&nbsp;`;
    //       }
    //     });
    //   }
    //   return data;
    // },
    getNumberToKorean(number) {
      return util.numberToKorean(number);
    },
    getTotalPrice(item) {
      console.log('getTotalPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      let promotionInfo = promotionCfg.getPriceInfo(item.telecom, telecomItem);

      console.log(promotionInfo);
      return promotionInfo.support + promotionInfo.gift;
    },
    getPromotionSupportPrice(item) {
      console.log('getPromotionSupportPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthSupportPrice(item.telecom, telecomItem);
    },
    getPromotionGiftPrice(item) {
      console.log('getPromotionGiftPrice');
      console.log(item);
      let telecomItem = this.getPromotionItem(item);

      return promotionCfg.getMonthGiftPrice(item.telecom, telecomItem);
    },
    getPromotionItem(item) {
      let itemArr = '';
      let telecomItem = '';
      if (item.item == '100M 인터넷') {
        itemArr = item.item.split(' ');
        telecomItem = itemArr[0];
      } else {
        itemArr = item.item.split('+');
        if (itemArr[0].indexOf('100M') != -1) {
          telecomItem = '100M';
        } else if (itemArr[0].indexOf('500M') != -1) {
          telecomItem = '500M';
        }

        if (itemArr[1].indexOf('TV') != -1) {
          telecomItem += '+TV';
        }
      }
      return telecomItem;
    },
    showDetailView() {
      var someElement = document.getElementById(`btn_detail`);
      someElement.classList.toggle('on');

      var infoSomeElement = document.getElementById(`more_info`);
      infoSomeElement.classList.toggle('on');
    },
  },
};
</script>

<style></style>
